export const environment = {
    production: false,
    redirectUri: 'https://dev.diaview.aws.postnord.com',
    postLogoutRedirectUri: 'https://dev.diaview.aws.postnord.com',
    diaBasePath: 'https://dev.diaview.aws.postnord.com/',
    baseUrl: 'https://dev.diaview.aws.postnord.com/',
    msalConfig: {
        auth: {
            clientId: '85000971-ea6e-41bd-8f54-6899746e30f1',
            authority: 'https://login.microsoftonline.com/91f09566-a850-4fae-bbe1-29ad3804a2f6'
        }
    },
    apiConfig: {
        scopes: ['openid', 'profile'],
        uri: 'https://graph.microsoft.com/v1.0/me',
        apirooturi: "https://dev.diaview.aws.postnord.com",
    },
    cams: {
        CAMERA_ID_1_DEVICE_ID: 'SNAP7938100008',
        CAMERA_ID_2_DEVICE_ID: 'SNAP7945200050',
        CAMERA_ID_3_DEVICE_ID: 'SNAP7983200060',
        MOBILE_CAMERA_1_DEVICE_ID: 'Hasta-359108090999770',
        MOBILE_CAMERA_2_DEVICE_ID: 'Hasta-359108091001675',
        MOBILE_CAMERA_3_DEVICE_ID: 'Hasta-359108090972744',
    },
    groups: {
        DIA_NormalUser_AT: 'ae29c23a-d73d-4325-8406-4d217828e208',
        DIA_CustomsUser_AT: 'b6c9fe56-b8e9-42aa-97d0-db5f1e3da54e'
    },

    bulkUpdateLimit: 25
    ,
};
